export const TASK_DRAG_TYPE = 'application/x-dashboard-task'
